import React from 'react'

/**
 * LCARS easter-egg toggle — clicking the small "X1" flips `body.lcars-mode`.
 *
 * This was historically buried inside the network-switcher dropdown ("Switch
 * between different <X1> network environments"). The network selector was
 * removed (2026-08: explorer is mainnet-only), so the enable path is preserved
 * here as a tiny standalone control. Persistence + boot-apply + the off path
 * still live in ThemeSwitcher.tsx (reads localStorage['lcars-mode'] on load);
 * this component is only the "turn it ON" entry point.
 */
export const LcarsToggle: React.FC = () => {
  const activate = (e: React.MouseEvent) => {
    e.stopPropagation()
    const isLcarsMode = document.body.classList.toggle('lcars-mode')
    if (isLcarsMode) {
      localStorage.setItem('lcars-mode', 'true')
      const toast = document.createElement('div')
      toast.className = 'fixed bottom-4 right-4 z-[9999] bg-[#FF9900] text-black px-6 py-4 rounded-[20px] shadow-lg transform transition-all duration-500'
      toast.innerHTML = '<div class="font-bold text-sm uppercase tracking-wider">LCARS Interface Activated</div><div class="text-xs mt-1">Welcome aboard, Captain.</div>'
      document.body.appendChild(toast)
      setTimeout(() => {
        toast.style.transform = 'translateY(100%)'
        toast.style.opacity = '0'
        setTimeout(() => toast.remove(), 500)
      }, 4000)
    } else {
      localStorage.removeItem('lcars-mode')
    }
  }

  return (
    <span
      onClick={activate}
      title="X1"
      aria-hidden="true"
      className="hidden sm:inline select-none cursor-default text-xs font-semibold tracking-wide text-gray-400/70 dark:text-gray-500/70 hover:text-gray-500 dark:hover:text-gray-400 transition-colors"
    >
      X1
    </span>
  )
}

export default LcarsToggle
